module.exports = __webpack_public_path__ + "static/media/winter-min.0cae9824.jpeg";